import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Tabs, Tab } from "@mui/material";
import { TabPanel } from "./TabPanel";
import AuthorizationUsers from "./users";
import JobAuthorization from "./job-authorization";
import OrganizationManagement from "./organization-management";
import { useAuthStore } from "../../authProvider";

/**
 * Main authorization management page that integrates all the components
 * Manages data and state while delegating UI rendering to the components
 */
export default function AuthorizationEditor() {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuthStore();

  // Organizations tab is only visible to admins
  const showOrganizations = user?.isAdmin;

  // Get the current tab from the URL
  const getTabFromUrl = (): number => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab");
    return tab ? parseInt(tab, 10) : 0;
  };

  // Current tab value from URL
  const tabValue = getTabFromUrl();

  // Handle tab change by updating the URL
  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", newValue.toString());
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  return (
    <Box sx={{ width: "100%", p: 3 }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          aria-label="authorization tabs"
        >
          <Tab label="Internal Users" />
          {showOrganizations && <Tab label="Organizations" />}
          <Tab label="Copywriter Assignment" />
        </Tabs>
      </Box>

      <TabPanel value={tabValue} index={0}>
        <AuthorizationUsers />
      </TabPanel>

      {showOrganizations && (
        <TabPanel value={tabValue} index={1}>
          <OrganizationManagement />
        </TabPanel>
      )}

      <TabPanel value={tabValue} index={showOrganizations ? 2 : 1}>
        <JobAuthorization />
      </TabPanel>
    </Box>
  );
}
